module.exports = __webpack_public_path__ + "static/img/detail-trainW.1bbee1e1.png";